import { render, staticRenderFns } from "./UserUpdateButton.vue?vue&type=template&id=3b2bf4ab&"
import script from "./UserUpdateButton.vue?vue&type=script&lang=js&"
export * from "./UserUpdateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports